import {ColumnDataType, DataTable, Modal} from "@tag/tag-components-react-v4";
import moment from "moment";
import {OctopusSyncAction} from "../types/OctopusSyncAction";
import {ProjectAccents} from "../../General/config/projectAccents";

function APPOctoSyncDetailsModal(props: {
    visible: boolean,
    heading: string,
    actions: OctopusSyncAction[],
    handleClose: Function
}) {
    const columns = [
        {accessorKey: 'order', header: '#', meta: {dataType: 'integer' as ColumnDataType}},
        {accessorKey: 'operation', header: 'Operation', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'tenantName', header: 'Tenant', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'appGroup', header: 'App Group', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'projectName', header: 'Project', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'reason', header: 'Why', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'outcome', header: 'Outcome', meta: {dataType: 'string' as ColumnDataType}},
        {accessorKey: 'time', header: 'Time', meta: {dataType: 'string' as ColumnDataType}},
    ];

    const data = props.actions.map((action) => ({
        order: action.order,
        operation: action.operation,
        tenantName: action.tenantName,
        appGroup: action.appGroup,
        projectName: action.projectName,
        reason: action.reason,
        outcome: action.succeeded ? 'Succeeded' : `Failed - ${action.error ?? 'unknown error'}`,
        time: moment.utc(action.timeStampUtc).local().format('HH:mm:ss'),
        succeeded: action.succeeded
    }));

    return (
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={props.heading}
            subHeading="Everything the sync did, in the order it happened"
            width="large"
            primaryButtonProps={{text: 'Close'}}
            cancelButtonProps={{style: {display: 'none'}}}
            onPrimaryButtonClick={() => props.handleClose()}
            onClose={() => props.handleClose()}
        >
            {data.length === 0
                ? <p>The sync made no changes in Octopus.</p>
                : <DataTable
                    scrollerProps={{
                        style: {width: 'unset'}
                    }}
                    getRowProps={(row) => ({
                        style: {
                            backgroundColor: row.original.succeeded ? undefined : '#FDECEA'
                        },
                    })}
                    columns={columns}
                    data={data}
                />
            }
        </Modal>
    );
}

export default APPOctoSyncDetailsModal;
